    import React from 'react';
    import { Link } from 'react-router-dom';
    const HeroSection = () => {
        const members = [
            "../images/Clients/client1.jpg",
            "../images/Clients/client12.jpg",
            "../images/Clients/client13.jpg",
            "../images/Clients/client14.jpg",
            "../images/Clients/client15.jpg",
            "../images/Clients/client16.jpg",
          ];
    return (
        <section className="relative">
        {/* Container */}
        <div className="mx-auto w-full max-w-7xl px-5 py-2 pt-8 md:px-10 md:py-22 lg:py-24 md:pb-0 lg:pb-0">
            {/* Heading Div */}
            <div className="mx-auto mb-4 w-full max-w-3xl text-center md:mb-16 lg:mb-10">
            <h1 className="mb-4 text-4xl font-semibold md:text-6xl">Empowering Your Business with Smart {" "} 
                <span className="rectangle-wrapper"><span className="pulsing-text">Tech Solutions</span></span> </h1>
            <p className="mx-auto mb-5 text-[17px] md:text-[20px] max-w-[528px] text-xl text-[#636262] lg:mb-8">
            From Concept to Completion, Fast and Seamless
            </p>
            {/* Button Wrap */}
            <div className="flex justify-center">
                
                <Link
                to="/showcase"
                className="flex max-w-full flex-row items-center justify-center rounded-xl border border-solid border-[#1353fe] px-6 py-3 font-semibold text-[#1353fe] [box-shadow:rgb(23,82,_147)_6px_6px]"
                >
                <img
                    src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905a575ec39b6784fc687c_Play.svg"
                    alt=""
                    className="mr-2 inline-block w-6"
                />
                <p className="text-black text-[12px] sm:text-[14px]">View Showcase</p>
                </Link>
                <Link
                to="/Service"
                className="ml-5 text-[12px] sm:text-[16px] inline-block rounded-xl bg-black px-8 py-4 text-center font-semibold text-white [box-shadow:rgb(23,82,_147)_6px_6px] md:mr-6"
                >
                Get Started
                </Link>
            </div>
            <div className="flex space-x-2 items-center justify-center mt-4 flex-col md:flex-row">
      <div className="flex -space-x-2 overflow-hidden p-2">
        {members.map((member, index) => (
          <img
            key={index}
              className="inline-block h-10 w-10 rounded-full ring-2 ring-gray-200 hover:scale-105 transform duration-100 object-cover object-center"
            src={member}
            alt={`Member ${index + 1}`}
          />
        ))}
      </div>
      <div>500+ Successful Satisfied Client</div>
    </div>
            </div>
            {/* Image Div */}
            
        </div>


     

        {/* BG Images */}
        <img
            src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905b9f809b5c8180ce30c5_pattern-1.svg"
            alt=""
            className="absolute bottom-0 left-0 right-auto top-0 -z-10 opacity-[0.2] sm:opacity-100 sm:inline-block fade-bounce-zoom"
        />
        <img
            src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905b9f809b5c8180ce30c5_pattern-1.svg"
            alt=""
            className="absolute bottom-0 left-[100px] right-auto top-[100px] -z-10 hidden sm:inline-block fade-bounce-zoom"
        />
        <img
            src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905ba1538296b3f50a905e_pattern-2.svg"
            alt=""
            className="absolute bottom-auto left-auto right-0 top-0 opacity-[0.2] sm:opacity-100 -z-10  sm:inline-block fade-bounce-zoom"
        />
        <img
            src="https://assets.website-files.com/63904f663019b0d8edf8d57c/63905ba1538296b3f50a905e_pattern-2.svg"
            alt=""
            className="absolute bottom-auto left-auto right-[100px] top-[100px] -z-10 hidden sm:inline-block fade-bounce-zoom"
        />
        </section>
    );
    };

    export default HeroSection;
